import {Companies, Properties} from "./models.js";

function Objective(name) {

    // Boolean
    const completed = false;
    const past = false;
    const failed = false;

    // Strings
    const helpText = null;
    const type = null;
    const eventName = null;

    // Foreign keys
    const companyId = null;

    return {
        name,
        completed,
        past,
        failed,
        helpText,
        type,
        eventName,
        companyId,
    };
}

function getObjectiveCompany(objective) {
    return Companies.find({'$loki': objective.companyId})[0];
}

function addObjectiveProperties(objective, properties) {
    properties.forEach(c => {
        c.objectiveId = objective.$loki
    });
}

function removeObjectiveProperties(objective, properties) {
    properties.forEach(c => {
        c.objectiveId = null
    });
}

function getObjectiveProperties(objective) {
    return Properties.find({'objectiveId': objective.$loki});
}

export { Objective, getObjectiveCompany, addObjectiveProperties, removeObjectiveProperties, getObjectiveProperties}
